<template>
    <section class="relative container-1 lib-paddings" id="contact-us">
        <div class="content-max-width content">
            <div class="vector-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="236" height="373" viewBox="0 0 236 373" fill="none">
                    <path
                        d="M206.06 125.957L95.2372 317.908C68.1017 364.908 0.26307 364.908 -26.8724 317.908L-137.695 125.957C-164.831 78.9575 -130.911 20.2074 -76.6405 20.2075L145.005 20.2075C199.276 20.2075 233.196 78.9575 206.06 125.957Z"
                        stroke="#100E43"
                        stroke-width="39"
                    />
                </svg>
            </div>

            <div class="vector-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="336" height="670" viewBox="0 0 336 670" fill="none">
                    <path
                        d="M561.884 22.3185C614.306 8.27219 662.275 56.2414 648.229 108.663L517.086 598.094C503.04 650.516 437.513 668.074 399.138 629.698L40.8494 271.41C2.47404 233.035 20.032 167.507 72.4536 153.461L561.884 22.3185Z"
                        stroke="#100E43"
                        stroke-width="39"
                    />
                </svg>
            </div>
            <Text1 class="text-center subtitle">Contact <span class="lib-color-orange">Us</span></Text1>

            <div class="container-contact">
                <div class="container-icon">
                    <div class="contact-us-icon">
                        <a href="/" class="p-0">
                            <svg width="177" height="93" viewBox="0 0 177 93" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_552_1439)">
                                    <path
                                        d="M50.3707 66.9806C45.8968 67.2711 41.4717 67.5553 37.0039 67.8458C37.0406 67.7407 37.0589 67.6604 37.0895 67.5862C39.4976 61.0669 41.9057 54.5475 44.3077 48.022C46.2085 42.8807 48.1032 37.7394 49.9979 32.5919C50.0773 32.3694 50.1751 32.2891 50.4196 32.2891C55.7247 32.3385 61.036 32.3818 66.3412 32.425C67.7347 32.4374 69.1282 32.4497 70.5217 32.4559C70.6195 32.4559 70.7173 32.4559 70.8762 32.4559C66.2067 39.9578 61.5677 47.4102 56.8921 54.9183C62.2217 54.3127 67.4963 53.7071 72.8443 53.0954C61.7633 66.4059 50.7191 79.6733 39.6809 92.9344C39.6626 92.9282 39.6504 92.9159 39.632 92.9097C43.2075 84.2893 46.783 75.6566 50.3707 66.9806Z"
                                        fill="url(#paint0_linear_552_1439)"
                                    />
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M29.134 53.2037H19.2021V48.0932C19.2021 46.7152 19.7644 45.4546 20.6628 44.5524C21.5552 43.6378 22.802 43.0755 24.165 43.0755C25.5279 43.0755 26.7747 43.644 27.6793 44.5524C28.5717 45.4546 29.134 46.7152 29.134 48.0932V53.2037ZM41.315 84.0516H21.8302H16.47H2.41871C1.81974 84.0516 1.30023 83.823 0.884615 83.3842C0.475116 82.9455 0.26731 82.414 0.29787 81.8084L2.926 24.2405C2.98712 23.0911 3.91613 22.1889 5.04684 22.1889H16.739L16.7512 13.6241C16.9162 9.935 18.4992 6.62898 20.9501 4.24988C23.4132 1.86461 26.7503 0.40625 30.3991 0.40625C34.0602 0.40625 37.3851 1.86461 39.8604 4.2437C42.3113 6.6228 43.8943 9.92882 44.0532 13.618L44.0654 22.1827H55.5069C56.6437 22.1827 57.5789 23.0849 57.6278 24.2343L57.915 30.5065C55.4214 30.4879 52.9277 30.4632 50.4401 30.4385C49.4256 30.4323 48.6432 30.9761 48.2887 31.9401C46.6691 36.3522 45.0372 40.7644 43.4114 45.1704L35.3803 66.9283C35.3498 67.0086 35.3253 67.0828 35.2948 67.1755L34.433 69.845L47.5492 68.9984L41.315 84.0516ZM34.0907 48.0932C34.0907 45.3372 32.9722 42.8222 31.1753 41.0116C29.9407 39.7633 28.3883 38.8364 26.6403 38.3791V22.1889H39.1147V13.7292C38.9864 11.4181 37.984 9.34177 36.4377 7.84634C34.8792 6.33854 32.7461 5.40544 30.4052 5.40544C28.0705 5.40544 25.9374 6.33854 24.3789 7.84634C22.8264 9.34177 21.818 11.4181 21.6896 13.7292L21.7018 22.1827V38.3729C19.9661 38.8302 18.4075 39.751 17.1668 41.0054C15.3699 42.8222 14.2514 45.331 14.2514 48.0871V55.694V58.1967H18.1936V64.9261C18.1936 66.3042 19.2999 67.4288 20.6689 67.4288C22.0319 67.4288 23.1443 66.3103 23.1443 64.9261V58.2029H25.4485V65.0065C25.4485 66.3969 26.5547 67.5153 27.9299 67.5153C29.2929 67.5153 30.4052 66.3969 30.4052 65.0065V58.2029H34.0968V48.0932H34.0907ZM59.7853 71.6432L49.4561 84.0516H58.1289C58.7401 84.0516 59.2474 83.823 59.6692 83.3842C60.0787 82.9455 60.2803 82.414 60.2498 81.8084L59.7853 71.6432Z"
                                        fill="white"
                                    />
                                    <path d="M92.5378 36.3663V42.2368H103.9V49.8438H92.5378V56.326H105.416V64.3408H82.6426V28.3516H105.416V36.3663H92.5378Z" fill="white" />
                                    <path d="M120.216 56.6844H131.272V64.3408H110.314V28.3516H120.21V56.6844H120.216Z" fill="white" />
                                    <path
                                        d="M168.281 28.3516H166.747H164.748H159.675H151.974H147.073H146.358H146.241H135.105V64.347H145.001V44.3317L151.767 64.347H160.048L166.765 44.4862V64.347H176.66V28.3516H168.281Z"
                                        fill="white"
                                    />
                                    <path
                                        d="M155.738 47.0022C154.602 47.0022 153.471 47.0084 152.334 47.0022C151.13 46.9898 150.5 46.3904 150.488 45.2719C150.482 44.7467 150.482 44.2152 150.488 43.69C150.5 42.553 150.097 41.5519 149.309 40.6868C148.05 39.3087 146.968 37.8257 146.161 36.1757C144.651 33.086 145.055 30.0642 146.693 27.1599C148.233 24.4224 150.623 22.5809 153.929 22.0062C157.688 21.3512 160.842 22.5253 163.335 25.1639C165.469 27.4256 166.41 30.1137 166.22 33.1169C166.098 35.0387 165.194 36.7195 164.087 38.3015C163.537 39.0924 162.92 39.8525 162.278 40.5817C161.422 41.5519 160.964 42.6271 161.019 43.8877C161.037 44.3759 161.037 44.8703 161.019 45.3584C160.976 46.4213 160.347 46.996 159.204 47.0084C158.049 47.0145 156.894 47.0022 155.738 47.0022ZM147.567 32.054C147.548 32.8821 147.988 33.4197 148.716 33.4321C149.425 33.4444 149.877 32.9686 149.914 32.1653C150.06 28.5812 152.927 26.2206 155.781 26.2453C156.502 26.2515 156.973 25.7077 156.924 25.1145C156.875 24.5089 156.343 24.0454 155.628 24.1258C154.779 24.2185 153.899 24.2864 153.116 24.5769C149.504 25.9178 147.897 28.5873 147.567 32.054Z"
                                        fill="url(#paint1_linear_552_1439)"
                                    />
                                    <path
                                        d="M155.926 21.8138C158.817 21.8138 161.298 22.9879 163.333 25.1507C165.466 27.4124 166.408 30.1004 166.218 33.1037C166.096 35.0255 165.191 36.7063 164.085 38.2882C163.535 39.0792 162.918 39.8331 162.276 40.5685C161.42 41.5386 160.962 42.6139 161.017 43.8745C161.035 44.3627 161.035 44.857 161.017 45.3452C160.974 46.4081 160.345 46.9828 159.202 46.9951C158.749 47.0013 158.297 47.0013 157.845 47.0013C157.148 47.0013 156.457 46.9951 155.761 46.9951C155.755 46.9951 155.742 46.9951 155.736 46.9951C155.039 46.9951 154.349 47.0013 153.652 47.0013C153.212 47.0013 152.772 47.0013 152.332 46.9951C151.128 46.9828 150.498 46.3833 150.486 45.2649C150.48 44.7396 150.48 44.2082 150.486 43.6829C150.498 42.5459 150.095 41.5448 149.306 40.6797C148.047 39.3017 146.966 37.8186 146.159 36.1687C144.649 33.0789 145.053 30.0572 146.691 27.1528C148.231 24.4153 150.62 22.5738 153.927 21.9991C154.618 21.8756 155.284 21.8138 155.926 21.8138ZM148.744 33.4312C149.435 33.4312 149.875 32.9553 149.911 32.1644C150.058 28.5988 152.888 26.2444 155.73 26.2444C155.748 26.2444 155.761 26.2444 155.779 26.2444C155.785 26.2444 155.785 26.2444 155.791 26.2444C156.506 26.2444 156.971 25.7006 156.922 25.1136C156.873 24.5513 156.415 24.1125 155.779 24.1125C155.73 24.1125 155.675 24.1125 155.626 24.1187C154.777 24.2114 153.896 24.2794 153.114 24.5698C149.502 25.9108 147.901 28.5865 147.565 32.047C147.546 32.875 147.986 33.4126 148.714 33.425C148.726 33.4312 148.732 33.4312 148.744 33.4312ZM155.926 20.2812C155.192 20.2812 154.434 20.3492 153.67 20.479C150.064 21.1093 147.198 23.1485 145.37 26.3866C143.353 29.9707 143.158 33.4868 144.796 36.8422C145.609 38.5169 146.721 40.1112 148.188 41.7178C148.726 42.3049 148.97 42.9228 148.964 43.6644C148.958 44.202 148.958 44.7396 148.964 45.2772C148.976 47.2361 150.29 48.5153 152.313 48.5338C152.76 48.54 153.206 48.54 153.646 48.54C154 48.54 154.361 48.54 154.715 48.54H155.73H156.787H157.833C158.291 48.54 158.749 48.54 159.208 48.5338C161.151 48.5153 162.453 47.2855 162.527 45.4132C162.551 44.8385 162.551 44.3132 162.527 43.8127C162.49 43.0155 162.771 42.3111 163.401 41.5943C164.158 40.7291 164.788 39.9443 165.32 39.1781C166.359 37.6888 167.569 35.6681 167.728 33.2087C167.954 29.7235 166.842 26.6523 164.427 24.094C162.05 21.5604 159.189 20.2812 155.926 20.2812Z"
                                        fill="#0B0A2E"
                                    />
                                    <path
                                        d="M152.686 50.7017C151.946 50.7264 151.403 50.3309 151.317 49.7315C151.225 49.1135 151.653 48.5698 152.399 48.4832C154.569 48.2361 156.744 48.0136 158.914 47.8035C159.593 47.7355 160.155 48.199 160.222 48.7984C160.295 49.4163 159.837 49.9601 159.11 50.0405C157.307 50.2382 155.504 50.4174 153.695 50.6028C153.352 50.6337 153.004 50.6708 152.686 50.7017Z"
                                        fill="url(#paint2_linear_552_1439)"
                                    />
                                    <path
                                        d="M159.045 47.7887C159.663 47.7887 160.158 48.2274 160.225 48.7898C160.298 49.4077 159.84 49.9515 159.113 50.0318C157.31 50.2296 155.507 50.4088 153.697 50.5942C153.349 50.6312 153.001 50.6683 152.677 50.6992C152.658 50.6992 152.634 50.6992 152.616 50.6992C151.907 50.6992 151.393 50.3161 151.308 49.729C151.216 49.1111 151.644 48.5673 152.39 48.4808C154.559 48.2336 156.735 48.0111 158.905 47.801C158.96 47.7887 159.003 47.7887 159.045 47.7887ZM159.045 46.25C158.954 46.25 158.862 46.2562 158.77 46.2624C156.24 46.5095 154.156 46.7258 152.224 46.9483C151.436 47.041 150.758 47.4117 150.305 47.9988C149.884 48.5549 149.706 49.2409 149.81 49.9453C150.006 51.2863 151.161 52.2256 152.622 52.2256C152.658 52.2256 152.689 52.2256 152.726 52.2256H152.781L152.836 52.2194L153.129 52.1885L153.85 52.1143L155.421 51.9537C156.705 51.8239 157.988 51.6941 159.272 51.552C160.054 51.4655 160.732 51.1009 161.191 50.5138C161.619 49.97 161.808 49.2903 161.722 48.5982C161.576 47.2634 160.421 46.25 159.045 46.25Z"
                                        fill="#0B0A2E"
                                    />
                                    <path
                                        d="M152.537 53.7321C151.913 53.7444 151.363 53.2933 151.308 52.6939C151.259 52.076 151.718 51.5692 152.457 51.4827C153.502 51.3591 154.554 51.2603 155.599 51.149C156.644 51.0378 157.695 50.9266 158.74 50.8215C159.517 50.7474 160.109 51.1367 160.219 51.7608C160.323 52.3911 159.877 52.9596 159.107 53.0461C156.937 53.2933 154.761 53.5034 152.537 53.7321Z"
                                        fill="url(#paint3_linear_552_1439)"
                                    />
                                    <path
                                        d="M158.928 50.8043C159.607 50.8043 160.12 51.1813 160.218 51.756C160.322 52.3863 159.875 52.9548 159.105 53.0413C156.936 53.2885 154.76 53.4986 152.535 53.7272C152.529 53.7272 152.523 53.7272 152.511 53.7272C151.899 53.7272 151.355 53.2823 151.307 52.6891C151.258 52.0711 151.716 51.5644 152.456 51.4779C153.501 51.3543 154.552 51.2554 155.597 51.1442C156.642 51.033 157.693 50.9217 158.739 50.8167C158.806 50.8043 158.867 50.8043 158.928 50.8043ZM158.928 49.2656C158.818 49.2656 158.708 49.2718 158.592 49.2842C157.852 49.3583 157.113 49.4325 156.373 49.5128L155.444 49.6117C155.139 49.6426 154.833 49.6735 154.521 49.7044C153.788 49.7785 153.03 49.8527 152.278 49.9454C150.738 50.1246 149.669 51.3605 149.791 52.8126C149.907 54.1845 151.099 55.2597 152.511 55.2597H152.523H152.559H152.621L152.682 55.2535C153.311 55.1856 153.941 55.1238 154.57 55.062C156.11 54.9075 157.706 54.7468 159.27 54.5676C160.083 54.4749 160.786 54.0856 161.238 53.48C161.66 52.9115 161.831 52.2132 161.715 51.5026C161.495 50.1802 160.352 49.2656 158.928 49.2656Z"
                                        fill="#0B0A2E"
                                    />
                                    <path
                                        d="M152.625 54.3894C154.728 54.1731 156.799 53.9568 158.92 53.7344C158.92 54.1422 158.963 54.5068 158.914 54.859C158.829 55.4708 158.303 55.9034 157.625 55.9157C156.414 55.9343 155.198 55.9343 153.988 55.9157C153.09 55.9034 152.619 55.3781 152.625 54.3894Z"
                                        fill="url(#paint4_linear_552_1439)"
                                    />
                                    <path
                                        d="M158.919 53.7446C158.919 54.1524 158.962 54.517 158.913 54.8693C158.827 55.481 158.301 55.9136 157.623 55.926C157.006 55.9383 156.395 55.9383 155.777 55.9383C155.178 55.9383 154.579 55.9321 153.986 55.926C153.1 55.9136 152.63 55.3883 152.636 54.3996C154.726 54.1772 156.798 53.9609 158.919 53.7446ZM160.435 52.0391L158.76 52.2121L155.062 52.5952L152.465 52.8671L151.108 53.0092L151.102 54.3873C151.095 56.1978 152.238 57.4276 153.95 57.4585C154.555 57.4708 155.16 57.4708 155.765 57.4708C156.388 57.4708 157.012 57.4646 157.635 57.4585C159.053 57.4337 160.221 56.4388 160.41 55.0794C160.459 54.7086 160.453 54.3687 160.441 54.0721C160.435 53.9671 160.435 53.8558 160.435 53.7446V52.0391Z"
                                        fill="#0B0A2E"
                                    />
                                    <path
                                        d="M155.738 47.01C154.602 47.01 153.471 47.0162 152.334 47.01C151.13 46.9976 150.5 46.3982 150.488 45.2797C150.482 44.7545 150.482 44.223 150.488 43.6978C150.5 42.5608 150.097 41.5597 149.309 40.6946C148.05 39.3165 146.968 37.8335 146.161 36.1835C144.651 33.0938 145.055 30.072 146.693 27.1677C148.233 24.4302 150.623 22.5887 153.929 22.014C157.688 21.359 160.842 22.5331 163.335 25.1717C165.469 27.4334 166.41 30.1215 166.22 33.1247C166.098 35.0465 165.194 36.7273 164.087 38.3093C163.537 39.1003 162.92 39.8603 162.278 40.5895C161.422 41.5597 160.964 42.6349 161.019 43.8955C161.037 44.3837 161.037 44.8781 161.019 45.3662C160.976 46.4291 160.347 47.0038 159.204 47.0162C158.049 47.0223 156.894 47.01 155.738 47.01ZM147.567 32.0618C147.548 32.8899 147.988 33.4275 148.716 33.4399C149.425 33.4522 149.877 32.9764 149.914 32.1731C150.06 28.589 152.927 26.2284 155.781 26.2531C156.502 26.2593 156.973 25.7155 156.924 25.1223C156.875 24.5167 156.343 24.0532 155.628 24.1336C154.779 24.2263 153.899 24.2942 153.116 24.5847C149.504 25.9256 147.897 28.5952 147.567 32.0618Z"
                                        fill="url(#paint5_linear_552_1439)"
                                    />
                                    <path
                                        d="M152.69 50.6782C151.95 50.703 151.406 50.3075 151.321 49.7081C151.229 49.0901 151.657 48.5463 152.403 48.4598C154.572 48.2126 156.748 47.9902 158.918 47.7801C159.596 47.7121 160.159 48.1756 160.226 48.775C160.299 49.3929 159.841 49.9367 159.114 50.017C157.311 50.2148 155.508 50.394 153.698 50.5794C153.356 50.6103 153.008 50.6473 152.69 50.6782Z"
                                        fill="url(#paint6_linear_552_1439)"
                                    />
                                    <path
                                        d="M152.541 53.7399C151.917 53.7522 151.367 53.3011 151.312 52.7017C151.263 52.0838 151.722 51.577 152.461 51.4905C153.506 51.3669 154.558 51.2681 155.603 51.1568C156.648 51.0456 157.699 50.9344 158.744 50.8293C159.52 50.7552 160.113 51.1445 160.223 51.7686C160.327 52.3989 159.881 52.9674 159.111 53.0539C156.941 53.3011 154.765 53.5112 152.541 53.7399Z"
                                        fill="url(#paint7_linear_552_1439)"
                                    />
                                    <path
                                        d="M152.629 54.405C154.731 54.1887 156.803 53.9725 158.924 53.75C158.924 54.1578 158.967 54.5224 158.918 54.8747C158.833 55.4864 158.307 55.919 157.629 55.9314C156.418 55.9499 155.202 55.9499 153.992 55.9314C153.093 55.919 152.623 55.3937 152.629 54.405Z"
                                        fill="url(#paint8_linear_552_1439)"
                                    />
                                    <path d="M86.046 77.9751H89.3037V80.2306H83.1367V69.6328H86.0521V77.9751H86.046Z" fill="url(#paint9_linear_552_1439)" />
                                    <path d="M96.8431 69.6328V80.2306H93.9277V69.6328H96.8431Z" fill="url(#paint10_linear_552_1439)" />
                                    <path
                                        d="M108.687 73.1293C108.516 72.8513 108.29 72.635 107.997 72.4805C107.703 72.3322 107.361 72.258 106.964 72.258C106.23 72.258 105.656 72.499 105.234 72.981C104.812 73.463 104.604 74.1057 104.604 74.9214C104.604 75.8359 104.831 76.528 105.283 77.0039C105.735 77.4797 106.389 77.7207 107.251 77.7207C108.272 77.7207 108.999 77.2572 109.439 76.3241H106.511V74.2046H111.951V77.0595C111.725 77.6218 111.389 78.1471 110.949 78.6353C110.509 79.1234 109.952 79.5313 109.274 79.8464C108.602 80.1616 107.832 80.3222 106.97 80.3222C105.918 80.3222 104.989 80.0936 104.183 79.6363C103.376 79.179 102.752 78.5426 102.312 77.7269C101.872 76.9112 101.652 75.9781 101.652 74.9214C101.652 73.8771 101.872 72.9501 102.312 72.1344C102.752 71.3188 103.376 70.6823 104.177 70.225C104.977 69.7677 105.906 69.5391 106.957 69.5391C108.278 69.5391 109.366 69.8604 110.227 70.5031C111.089 71.1457 111.627 72.0232 111.835 73.1355H108.687V73.1293Z"
                                        fill="url(#paint11_linear_552_1439)"
                                    />
                                    <path d="M126.136 69.6328V80.2306H123.22V75.9791H119.669V80.2306H116.754V69.6328H119.669V73.6186H123.22V69.6328H126.136Z" fill="url(#paint12_linear_552_1439)" />
                                    <path d="M139.184 69.6328V71.9748H136.391V80.2244H133.475V71.9748H130.713V69.6328H139.184Z" fill="url(#paint13_linear_552_1439)" />
                                    <path d="M146.669 69.6328V80.2306H143.754V69.6328H146.669Z" fill="url(#paint14_linear_552_1439)" />
                                    <path d="M161.546 80.2306H158.63L154.749 74.3107V80.2306H151.834V69.6328H154.749L158.63 75.6331V69.6328H161.546V80.2306Z" fill="url(#paint15_linear_552_1439)" />
                                    <path
                                        d="M173.386 73.1293C173.215 72.8513 172.989 72.635 172.696 72.4805C172.402 72.3322 172.06 72.258 171.663 72.258C170.929 72.258 170.355 72.499 169.933 72.981C169.511 73.463 169.304 74.1057 169.304 74.9214C169.304 75.8359 169.53 76.528 169.982 77.0039C170.434 77.4797 171.088 77.7207 171.95 77.7207C172.971 77.7207 173.698 77.2572 174.138 76.3241H171.211V74.2046H176.65V77.0595C176.424 77.6218 176.088 78.1471 175.648 78.6353C175.208 79.1234 174.652 79.5313 173.973 79.8464C173.301 80.1616 172.531 80.3222 171.669 80.3222C170.618 80.3222 169.689 80.0936 168.882 79.6363C168.075 79.179 167.452 78.5426 167.012 77.7269C166.572 76.9112 166.352 75.9781 166.352 74.9214C166.352 73.8771 166.572 72.9501 167.012 72.1344C167.452 71.3188 168.075 70.6823 168.876 70.225C169.676 69.7677 170.605 69.5391 171.657 69.5391C172.977 69.5391 174.065 69.8604 174.927 70.5031C175.788 71.1457 176.326 72.0232 176.534 73.1355H173.386V73.1293Z"
                                        fill="url(#paint16_linear_552_1439)"
                                    />
                                </g>
                                <defs>
                                    <linearGradient id="paint0_linear_552_1439" x1="37.0053" y1="62.6182" x2="72.8451" y2="62.6182" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#EB1B24" />
                                        <stop offset="0.1059" stop-color="#EE3423" />
                                        <stop offset="0.2758" stop-color="#F15622" />
                                        <stop offset="0.4494" stop-color="#F47120" />
                                        <stop offset="0.6259" stop-color="#F68420" />
                                        <stop offset="0.8071" stop-color="#F88F1F" />
                                        <stop offset="1" stop-color="#F8931F" />
                                    </linearGradient>
                                    <linearGradient id="paint1_linear_552_1439" x1="138.062" y1="52.2896" x2="171.271" y2="19.444" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#EB1B24" />
                                        <stop offset="0.1059" stop-color="#EE3423" />
                                        <stop offset="0.2758" stop-color="#F15622" />
                                        <stop offset="0.4494" stop-color="#F47120" />
                                        <stop offset="0.6259" stop-color="#F68420" />
                                        <stop offset="0.8071" stop-color="#F88F1F" />
                                        <stop offset="1" stop-color="#F8931F" />
                                    </linearGradient>
                                    <linearGradient id="paint2_linear_552_1439" x1="145.402" y1="59.7354" x2="178.611" y2="26.8898" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#EB1B24" />
                                        <stop offset="0.1059" stop-color="#EE3423" />
                                        <stop offset="0.2758" stop-color="#F15622" />
                                        <stop offset="0.4494" stop-color="#F47120" />
                                        <stop offset="0.6259" stop-color="#F68420" />
                                        <stop offset="0.8071" stop-color="#F88F1F" />
                                        <stop offset="1" stop-color="#F8931F" />
                                    </linearGradient>
                                    <linearGradient id="paint3_linear_552_1439" x1="146.9" y1="61.2368" x2="180.109" y2="28.3912" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#EB1B24" />
                                        <stop offset="0.1059" stop-color="#EE3423" />
                                        <stop offset="0.2758" stop-color="#F15622" />
                                        <stop offset="0.4494" stop-color="#F47120" />
                                        <stop offset="0.6259" stop-color="#F68420" />
                                        <stop offset="0.8071" stop-color="#F88F1F" />
                                        <stop offset="1" stop-color="#F8931F" />
                                    </linearGradient>
                                    <linearGradient id="paint4_linear_552_1439" x1="148.154" y1="62.4916" x2="181.363" y2="29.6459" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#EB1B24" />
                                        <stop offset="0.1059" stop-color="#EE3423" />
                                        <stop offset="0.2758" stop-color="#F15622" />
                                        <stop offset="0.4494" stop-color="#F47120" />
                                        <stop offset="0.6259" stop-color="#F68420" />
                                        <stop offset="0.8071" stop-color="#F88F1F" />
                                        <stop offset="1" stop-color="#F8931F" />
                                    </linearGradient>
                                    <linearGradient id="paint5_linear_552_1439" x1="138.062" y1="52.2974" x2="171.271" y2="19.4518" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#EB1B24" />
                                        <stop offset="0.1059" stop-color="#EE3423" />
                                        <stop offset="0.2758" stop-color="#F15622" />
                                        <stop offset="0.4494" stop-color="#F47120" />
                                        <stop offset="0.6259" stop-color="#F68420" />
                                        <stop offset="0.8071" stop-color="#F88F1F" />
                                        <stop offset="1" stop-color="#F8931F" />
                                    </linearGradient>
                                    <linearGradient id="paint6_linear_552_1439" x1="145.406" y1="59.7119" x2="178.614" y2="26.8664" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#EB1B24" />
                                        <stop offset="0.1059" stop-color="#EE3423" />
                                        <stop offset="0.2758" stop-color="#F15622" />
                                        <stop offset="0.4494" stop-color="#F47120" />
                                        <stop offset="0.6259" stop-color="#F68420" />
                                        <stop offset="0.8071" stop-color="#F88F1F" />
                                        <stop offset="1" stop-color="#F8931F" />
                                    </linearGradient>
                                    <linearGradient id="paint7_linear_552_1439" x1="146.904" y1="61.2446" x2="180.113" y2="28.399" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#EB1B24" />
                                        <stop offset="0.1059" stop-color="#EE3423" />
                                        <stop offset="0.2758" stop-color="#F15622" />
                                        <stop offset="0.4494" stop-color="#F47120" />
                                        <stop offset="0.6259" stop-color="#F68420" />
                                        <stop offset="0.8071" stop-color="#F88F1F" />
                                        <stop offset="1" stop-color="#F8931F" />
                                    </linearGradient>
                                    <linearGradient id="paint8_linear_552_1439" x1="148.158" y1="62.5072" x2="181.366" y2="29.6615" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#EB1B24" />
                                        <stop offset="0.1059" stop-color="#EE3423" />
                                        <stop offset="0.2758" stop-color="#F15622" />
                                        <stop offset="0.4494" stop-color="#F47120" />
                                        <stop offset="0.6259" stop-color="#F68420" />
                                        <stop offset="0.8071" stop-color="#F88F1F" />
                                        <stop offset="1" stop-color="#F8931F" />
                                    </linearGradient>
                                    <linearGradient id="paint9_linear_552_1439" x1="79.8476" y1="74.9341" x2="181.942" y2="74.9341" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#EB1B24" />
                                        <stop offset="0.1059" stop-color="#EE3423" />
                                        <stop offset="0.2758" stop-color="#F15622" />
                                        <stop offset="0.4494" stop-color="#F47120" />
                                        <stop offset="0.6259" stop-color="#F68420" />
                                        <stop offset="0.8071" stop-color="#F88F1F" />
                                        <stop offset="1" stop-color="#F8931F" />
                                    </linearGradient>
                                    <linearGradient id="paint10_linear_552_1439" x1="79.851" y1="74.9341" x2="181.945" y2="74.9341" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#EB1B24" />
                                        <stop offset="0.1059" stop-color="#EE3423" />
                                        <stop offset="0.2758" stop-color="#F15622" />
                                        <stop offset="0.4494" stop-color="#F47120" />
                                        <stop offset="0.6259" stop-color="#F68420" />
                                        <stop offset="0.8071" stop-color="#F88F1F" />
                                        <stop offset="1" stop-color="#F8931F" />
                                    </linearGradient>
                                    <linearGradient id="paint11_linear_552_1439" x1="79.8502" y1="74.9242" x2="181.944" y2="74.9242" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#EB1B24" />
                                        <stop offset="0.1059" stop-color="#EE3423" />
                                        <stop offset="0.2758" stop-color="#F15622" />
                                        <stop offset="0.4494" stop-color="#F47120" />
                                        <stop offset="0.6259" stop-color="#F68420" />
                                        <stop offset="0.8071" stop-color="#F88F1F" />
                                        <stop offset="1" stop-color="#F8931F" />
                                    </linearGradient>
                                    <linearGradient id="paint12_linear_552_1439" x1="79.8553" y1="74.9341" x2="181.949" y2="74.9341" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#EB1B24" />
                                        <stop offset="0.1059" stop-color="#EE3423" />
                                        <stop offset="0.2758" stop-color="#F15622" />
                                        <stop offset="0.4494" stop-color="#F47120" />
                                        <stop offset="0.6259" stop-color="#F68420" />
                                        <stop offset="0.8071" stop-color="#F88F1F" />
                                        <stop offset="1" stop-color="#F8931F" />
                                    </linearGradient>
                                    <linearGradient id="paint13_linear_552_1439" x1="79.8546" y1="74.9341" x2="181.949" y2="74.9341" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#EB1B24" />
                                        <stop offset="0.1059" stop-color="#EE3423" />
                                        <stop offset="0.2758" stop-color="#F15622" />
                                        <stop offset="0.4494" stop-color="#F47120" />
                                        <stop offset="0.6259" stop-color="#F68420" />
                                        <stop offset="0.8071" stop-color="#F88F1F" />
                                        <stop offset="1" stop-color="#F8931F" />
                                    </linearGradient>
                                    <linearGradient id="paint14_linear_552_1439" x1="79.8468" y1="74.9341" x2="181.941" y2="74.9341" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#EB1B24" />
                                        <stop offset="0.1059" stop-color="#EE3423" />
                                        <stop offset="0.2758" stop-color="#F15622" />
                                        <stop offset="0.4494" stop-color="#F47120" />
                                        <stop offset="0.6259" stop-color="#F68420" />
                                        <stop offset="0.8071" stop-color="#F88F1F" />
                                        <stop offset="1" stop-color="#F8931F" />
                                    </linearGradient>
                                    <linearGradient id="paint15_linear_552_1439" x1="79.8529" y1="74.9341" x2="181.947" y2="74.9341" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#EB1B24" />
                                        <stop offset="0.1059" stop-color="#EE3423" />
                                        <stop offset="0.2758" stop-color="#F15622" />
                                        <stop offset="0.4494" stop-color="#F47120" />
                                        <stop offset="0.6259" stop-color="#F68420" />
                                        <stop offset="0.8071" stop-color="#F88F1F" />
                                        <stop offset="1" stop-color="#F8931F" />
                                    </linearGradient>
                                    <linearGradient id="paint16_linear_552_1439" x1="79.8485" y1="74.9242" x2="181.943" y2="74.9242" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#EB1B24" />
                                        <stop offset="0.1059" stop-color="#EE3423" />
                                        <stop offset="0.2758" stop-color="#F15622" />
                                        <stop offset="0.4494" stop-color="#F47120" />
                                        <stop offset="0.6259" stop-color="#F68420" />
                                        <stop offset="0.8071" stop-color="#F88F1F" />
                                        <stop offset="1" stop-color="#F8931F" />
                                    </linearGradient>
                                    <clipPath id="clip0_552_1439">
                                        <rect width="176.366" height="92.5376" fill="white" transform="translate(0.298828 0.398438)" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </a>
                    </div>
                    <Text2 class="subtitle">
                        Contact
                        <span class="lib-color-orange">Information</span>
                    </Text2>

                    <ul>
                        <li>
                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_302_5)">
                                    <path
                                        d="M4.84569 9.20405C6.20842 11.8822 8.40394 14.0683 11.0821 15.4405L13.1641 13.3585C13.4196 13.103 13.7981 13.0178 14.1293 13.1314C15.1892 13.4815 16.3343 13.6708 17.5078 13.6708C18.0283 13.6708 18.4541 14.0967 18.4541 14.6171V17.9199C18.4541 18.4404 18.0283 18.8662 17.5078 18.8662C8.6216 18.8662 1.41992 11.6645 1.41992 2.77838C1.41992 2.25789 1.84578 1.83203 2.36627 1.83203H5.67847C6.19896 1.83203 6.62481 2.25789 6.62481 2.77838C6.62481 3.96131 6.81408 5.09692 7.16423 6.15682C7.26833 6.48804 7.19262 6.85712 6.92764 7.12209L4.84569 9.20405Z"
                                        fill="#F98F20"
                                    />
                                </g>
                                <defs>
                                    <clipPath id="clip0_302_5">
                                        <rect width="19.8732" height="19.8732" fill="white" transform="translate(0 0.414062)" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <ul class="lib-email-obfuscation">
                                <a href="tel:1-718-376-6608">
                                    <li>1</li>
                                    <li class="hidden">this is hidden</li>
                                    <li>-718-3</li>
                                    <li>76-66</li>
                                    <li>08</li>
                                </a>

                                <li class="hidden">this is hidden</li>
                                <li>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</li>
                                <li class="hidden">this is hidden</li>
                                <a href="tel:718-376-6622">
                                    <li>718-3</li>
                                    <li>76-66</li>
                                    <li>22</li>
                                    <li class="hidden">this is hidden</li>
                                </a>
                            </ul>
                        </li>

                        <a href="https://wa.me/17183766622">
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="36" height="36" viewBox="0 0 36 36" fill="none">
                                    <mask id="mask0_971_96766" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="36" height="36">
                                        <rect width="36" height="36" fill="url(#pattern02224)" />
                                    </mask>
                                    <g mask="url(#mask0_971_96766)">
                                        <rect x="-8.625" y="-11.25" width="55.125" height="59.25" fill="#F98F20" />
                                    </g>
                                    <defs>
                                        <pattern id="pattern02224" patternContentUnits="objectBoundingBox" width="1" height="1">
                                            <use xlink:href="#image0_971_967" transform="scale(0.0104167)" />
                                        </pattern>
                                        <image
                                            id="image0_971_967"
                                            width="96"
                                            height="96"
                                            xlink:href="data:image/png;base64,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"
                                        />
                                    </defs>
                                </svg>

                                <ul class="lib-email-obfuscation">
                                    <li class="hidden">this is hidden</li>
                                    <li>718-3</li>
                                    <li>76-66</li>
                                    <li>22</li>
                                    <li class="hidden">this is hidden</li>
                                </ul>
                            </li>
                        </a>
                        <a href="mailto: accounting@elmlighting.com">
                            <li>
                                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_302_8)">
                                        <path
                                            d="M16.5612 3.63281H3.31235C2.4015 3.63281 1.66453 4.37806 1.66453 5.28891L1.65625 15.2255C1.65625 16.1364 2.4015 16.8816 3.31235 16.8816H16.5612C17.472 16.8816 18.2173 16.1364 18.2173 15.2255V5.28891C18.2173 4.37806 17.472 3.63281 16.5612 3.63281ZM16.5612 6.94502L9.93676 11.0853L3.31235 6.94502V5.28891L9.93676 9.42917L16.5612 5.28891V6.94502Z"
                                            fill="#F98F20"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_302_8">
                                            <rect width="19.8732" height="19.8732" fill="white" transform="translate(0 0.324219)" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                <ul class="lib-email-obfuscation">
                                    <li>accounting@</li>
                                    <li class="hidden">this is hidden</li>
                                    <li>elmligh</li>
                                    <li>ting</li>
                                    <li>.com</li>
                                    <li class="hidden">this is hidden</li>
                                </ul>
                            </li>
                        </a>
                    </ul>
                </div>
                <div class="container-form">
                    <form @submit.prevent="sendMessage">
                        <input type="text" v-model="message.name" placeholder="Your Name" required />
                        <input type="email" v-model="message.email" placeholder="Email Address" required />
                        <textarea placeholder="Type Message..." rows="3" required v-model="message.message"></textarea>
                        <Button2 type="submit" class="submitbtn" :disabled="sending || done || !!error" :class="done && 'sent'">
                            <span class="relative flex items-center justify-center" v-html="error ? error : sendingtext"></span
                        ></Button2>
                    </form>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import Text1 from '@/components/Text1';
import Text2 from '@/components/Text2';
import Button2 from '@/components/Button2';
import axios from 'axios';

export default {
    components: {Text1, Text2, Button2},
    data() {
        return {
            sending: false,
            done: false,
            error: '',
            message: {
                message: '',
                name: '',
                email: '',
            },
        };
    },

    computed: {
        sendingtext() {
            if (this.done) {
                return `<svg width="19" height="17" class="pr-1" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_27_514)"><path d="M14.8813 4.23333C14.2662 4.76667 13.6682 5.3 13.0531 5.83333C10.9173 7.71667 8.79861 9.58333 6.66282 11.4667C6.52613 11.5833 6.40652 11.6167 6.21857 11.55C4.23656 10.9333 2.25454 10.3167 0.289614 9.7C0.238355 9.68333 0.17001 9.66667 0.101664 9.63333C-0.0350262 9.56667 -0.0521126 9.4 0.0845781 9.31667C0.152923 9.26667 0.238355 9.23333 0.323787 9.2C6.42361 6.16667 12.5063 3.11667 18.6062 0.0833333C18.6745 0.05 18.7599 0 18.8283 0C19.0162 0.0333333 19.0333 0.15 18.9821 0.3C18.6745 1.53333 18.367 2.75 18.0594 3.98333C17.2393 7.31667 16.402 10.6333 15.5819 13.9667C15.4965 14.3 15.4623 14.3167 15.1376 14.2167C12.9335 13.5667 10.7294 12.9 8.52523 12.25C8.1835 12.15 8.16642 12.05 8.38854 11.7833C10.5414 9.31667 12.6943 6.83333 14.8472 4.35C14.8643 4.31667 14.8984 4.3 14.9155 4.26667C14.8984 4.25 14.8984 4.25 14.8813 4.23333Z" fill="#FCFCFC"/><path d="M8.2356 15.0501C8.2356 14.5001 8.2356 13.9668 8.2356 13.4168C8.2356 13.1334 8.33811 13.0668 8.59441 13.1501C9.17534 13.3168 9.73919 13.4834 10.3201 13.6668C10.5764 13.7501 10.6106 13.8501 10.4739 14.0668C9.87588 15.0001 9.27786 15.9334 8.66275 16.8501C8.6115 16.9168 8.49189 16.9501 8.40646 17.0001C8.3552 16.9168 8.25268 16.8168 8.25268 16.7334C8.2356 16.1668 8.2356 15.6001 8.2356 15.0501Z" fill="#FCFCFC"/></g><defs><clipPath id="clip0_27_514"><rect width="19" height="17" fill="white"/></clipPath></defs></svg>
             MESSAGE SENT!`;
            }
            return this.sending ? `SENDING<div class="dot-pulse ml-6 absolute reloader"></div>` : 'Send Message';
        },
    },

    methods: {
        async sendMessage(e, url = 'https://api.indentations.app/xhr/web/contact') {
            // if (process.env.NODE_ENV == 'development') {
            //     url = 'http://localhost:3003/api/contact';
            // }

            // let result = {};
            // try {
            //     result = await fetch(url, {
            //         method: 'POST',
            //         headers: {
            //             Accept: 'application/json',
            //             'Content-Type': 'application/json',
            //         },
            //         body: JSON.stringify(this.message),
            //     });
            // } catch (err) {
            //     result.status = 500;
            // }

            // if (result.status === 200) {
            //     setTimeout(() => {
            //         this.done = true;
            //     }, 2000);
            // } else {
            //     document.querySelector('.submitbtn button').classList.add('cursor-not-allowed');
            //     this.error = 'Oops, something went wrong';
            // } finally {
            //     this.done = true
            //     this.sending = false
            // }

            e.preventDefault();
            this.sending = true;
            this.error = ''
            try {
                let res = await axios.post(url, this.message);
                 if(res.data.status !== 'received') {
                    throw 500
                }
            } catch (err) {
                this.error = 'Something went wrong';
            } finally {
                this.done = true
                this.sending = false;
            }

        },
    },
};
</script>
<style scoped lang="scss">
section {
    background: rgba(15, 13, 63, 1);
    overflow: hidden;
    .vector-1 {
        svg {
            width: 60vw;
        }
        position: absolute;
        left: -10vw;
        bottom: 0;
        pointer-events: none;
    }
    .vector-2 {
        width: 80vw;
        position: absolute;
        right: -50vw;
        top: 5%;
        pointer-events: none;
    }

    :deep(.container-contact) {
        display: grid;
        padding-top: 40px;
        grid-template-columns: none;
        position: relative;

        .subtitle {
            padding-top: 45px;
        }

        .contact-us-icon {
            display: flex;
            justify-content: center;
            svg {
                width: 135.67px;
                height: 71.18px;
            }
        }
        .container-form {
            padding-top: 26.45px;
            form {
                width: 100%;
                display: grid;
                row-gap: 8.47px;
                input,
                textarea {
                    width: 100%;
                    padding: 0 11.41px;
                    border-radius: 4px;
                    min-height: 37px;
                    border: transparent 3px solid;
                    font-size: 13px;
                    &:focus {
                        border: #0084fe 3px solid;
                    }
                }
                textarea {
                    padding-top: 9.57px;
                    padding-bottom: 9.57px;
                    min-height: 88.35px;
                    resize: none;
                }
                button {
                    min-height: 37px;
                }
            }
        }
        ul {
            padding-top: 27px;
            display: grid;
            row-gap: 17px;
            li {
                display: flex;
                font-size: 15px;
                line-height: 164.5%;
                align-items: center;
                color: white;
                svg {
                    margin-right: 12.78px;
                    width: 20px;
                    height: 20px;
                }
            }
        }

        .reloader {
            right: -22px;
        }

        .dot-pulse {
            position: relative;
            left: -9999px;
            width: 4px;
            height: 4px;
            border-radius: 5px;
            background-color: #9880ff;
            color: #9880ff;
            box-shadow: 9999px 0 0 -5px #9880ff;
            animation: dotPulse 1.5s infinite linear;
            animation-delay: 0.25s;
        }

        .dot-pulse::before,
        .dot-pulse::after {
            content: '';
            display: inline-block;
            position: absolute;
            top: 0;
            width: 4px;
            height: 4px;
            border-radius: 5px;
            background-color: #9880ff;
            color: #9880ff;
        }

        .dot-pulse::before {
            box-shadow: 9984px 0 0 -5px #9880ff;
            animation: dotPulseBefore 1.5s infinite linear;
            animation-delay: 0s;
        }

        .dot-pulse::after {
            box-shadow: 10014px 0 0 -5px white;
            animation: dotPulseAfter 1.5s infinite linear;
            animation-delay: 0.5s;
        }

        @keyframes dotPulseBefore {
            0% {
                box-shadow: 9984px 0 0 -5px white;
            }
            30% {
                box-shadow: 9984px 0 0 2px white;
            }
            60%,
            100% {
                box-shadow: 9984px 0 0 -5px white;
            }
        }

        @keyframes dotPulse {
            0% {
                box-shadow: 9999px 0 0 -5px white;
            }
            30% {
                box-shadow: 9999px 0 0 2px white;
            }
            60%,
            100% {
                box-shadow: 9999px 0 0 -5px white;
            }
        }

        @keyframes dotPulseAfter {
            0% {
                box-shadow: 10014px 0 0 -5px white;
            }
            30% {
                box-shadow: 10014px 0 0 2px white;
            }
            60%,
            100% {
                box-shadow: 10014px 0 0 -5px white;
            }
        }
        .sent {
            button {
                background: #bc5300;
            }
        }
    }
}

@media (min-width: 390px) {
    section {
        .container-contact {
            .contact-us-icon {
                svg {
                    width: 176.37px;
                    height: 92.54px;
                }
            }

            .subtitle {
                padding-top: 59px;
            }
            .container-form {
                padding-top: 34.51px;
                form {
                    row-gap: 11.11px;
                    input,
                    textarea {
                        padding: 0 15.46px;
                        border-radius: 5.24869px;
                        min-height: 42.02px;
                        font-size: 13px;
                    }
                    textarea {
                        padding-bottom: 12.56px;
                        padding-top: 12.56px;
                        min-height: 115.92px;
                    }
                    :deep(button) {
                        min-height: 42.02px;
                    }
                }
            }
            ul {
                padding-top: 35.16px;
                row-gap: 22.24px;
                li {
                    svg {
                        margin-right: 16.46px;
                        width: 26.08px;
                        height: 26.08px;
                    }
                }
            }
        }
    }
}

@media (min-width: 640px) {
    section {
        .container-contact {
            .subtitle {
                padding-top: 93px;
            }

            .contact-us-icon {
                svg {
                    width: 289.42px;
                    height: 151.86px;
                }
            }

            .container-form {
                padding-top: 57.66px;
                form {
                    row-gap: 18.23px;
                    input,
                    textarea {
                        padding: 0 24.58px;
                        border-radius: 8.61324px;
                        min-height: 68.96px;
                        font-size: 19.02px;
                    }
                    textarea {
                        padding-top: 20.62px;
                        padding-bottom: 20.62px;
                        min-height: 190.24px;
                    }
                    :deep(button) {
                        min-height: 68.96px;
                    }
                }
            }
            ul {
                padding-top: 57.12px;
                row-gap: 37.52px;
                li {
                    font-size: 24.45px;
                    svg {
                        margin-right: 27px;
                        width: 51px;
                        height: 51px;
                    }
                }
            }
        }
    }
}

@media (min-width: 768px) {
    section {
        .container-contact {
            .subtitle {
                padding-top: 116px;
            }

            .contact-us-icon {
                svg {
                    width: 347.3px;
                    height: 182.23px;
                }
            }

            .container-form {
                padding-top: 69.19px;
                form {
                    row-gap: 20.92px;
                    input,
                    textarea {
                        padding: 0 30.44px;
                        border-radius: 10.3359px;
                        min-height: 72.75px;
                        font-size: 22.83px;
                    }
                    textarea {
                        padding-top: 24.74px;
                        padding-bottom: 24.74px;
                        min-height: 228.28px;
                    }
                    :deep(button) {
                        min-height: 72.75px;
                    }
                }
            }
            ul {
                padding-top: 69.12px;
                row-gap: 45.02px;
                li {
                    font-size: 32px;
                    svg {
                        margin-right: 32.4px;
                        width: 51px;
                        height: 51px;
                    }
                }
            }
        }
    }
}

@media (min-width: 1280px) {
    section {
        .vector-1 {
            svg {
                width: auto;
            }
            left: 0;
            bottom: 0;
        }
        .vector-2 {
            width: auto;
            right: -20px;
            top: 20%;
        }
        .container-contact {
            padding-top: 80px;
            grid-template-columns: repeat(2, minmax(0, 1fr));

            .subtitle {
                padding-top: 38.42px;
            }
            .contact-us-icon {
                justify-content: flex-start;
            }

            div:nth-child(1) {
                font-size: 24px;
                line-height: 39px;
                svg {
                    margin-right: 22.5px;
                }
            }
            .container-form {
                padding-top: 0px;
                form {
                    max-width: 670px;
                    row-gap: 22px;
                    padding-left: 20px;
                    input,
                    textarea {
                        font-size: 18px;
                        padding: 0 32px;
                        border-radius: 4px;
                        min-height: 72.75px;
                    }
                    textarea {
                        padding-top: 36px;
                        min-height: 240px;
                    }
                    :deep(button) {
                        min-height: 72.75px;
                    }
                }
            }
            ul {
                padding-top: 30.65px;
                row-gap: 30.18px;
                li {
                    font-size: 19.95px;
                    svg {
                        margin-right: 21.62px;
                        width: 35px;
                        height: 35px;
                    }
                }
            }
        }
    }
}
</style>
